<script>
    const {
        class: className,
        icon
    } = $props();
</script>

<svg class={className}
     fill="currentColor"
     role="img"
     aria-label="envelope solid"
     viewBox="0 0 24 24"
     xmlns="http://www.w3.org/2000/svg">
    <g fill="currentColor">
        <path d="{icon}"></path>
    </g>
</svg>
